"use client";
// LEGACY UI: replace with Badge from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).
import classNames from "@casino/external/classNames";

type Props = {
  color?: string;
  bgColor?: string;
  size?: string;
  className?: string;
};

const Tag: FC<Props> = ({ children, color, bgColor, size, className }) => {
  const getSize =
    size === "2xs"
      ? "text-[9px] tracking-[0.0625rem] py-0 h-4"
      : "text-[10px] tracking-[0.0313rem] py-1 h-6";
  return (
    <div
      data-testid="tag-component"
      className={classNames(
        "flex items-center gap-1 select-none text-background bg-foreground rounded-[4px] leading-4 text-2xs-caption uppercase font-medium px-2",
        color,
        bgColor,
        getSize,
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Tag;
